"use strict";

angular.module("customer")
.component("paymentMethods", {
    bindings: {
        vendorId: "<?",
        selectedMethod: "=?",
        selectedBankAccount: "=?",
        selectedCreditCardAccount: "=?",
        form: "=",
        checkNumber: "=?",
        isCheckNumberMandatory: "=?"
    },
    templateUrl: require("./payment-methods.component.html"),
    controllerAs: 'paymentMethodsCtrl',
    controller: function(
        $scope, PaymentService, UserService, PatternService
    ) {
        $scope.vendorId = this.vendorId;
        $scope.pattern = PatternService;
        $scope.CHECK_NUMBER_MAXLENGTH = 8;

        $scope.paymentCheckNumberHelpTip = PaymentService.getPaymentCheckNumberHtmlContent();

        $scope.$on("LanguageChanged", function(obj, locale, short_code) {
            $scope.paymentCheckNumberHelpTip = PaymentService.getPaymentCheckNumberHtmlContent();
        });

        UserService.isUserFetched().then(function onSuccess(user) {
            if (user) {
                $scope.dedicatedVendorId = user.dedicated_vendor_id;
            }
        });

        if ($scope.vendorId) {
            PaymentService.getAllowedPaymentMethodChoicesLocalized($scope.vendorId)
            .then(function onSuccess(response) {
                $scope.methodChoicesLocalized = response.data;
            });
        }

        this.showCheckNumber = function() {
            return (
                this.selectedMethod === 'check'
                && $scope.methodChoicesLocalized
                && Object.keys($scope.methodChoicesLocalized).includes('check')
            );
        };
    }
});



//////////////////
// WEBPACK FOOTER
// ./customer/app-core/payment-methods/payment-methods.component.js
// module id = 870
// module chunks = 0